import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MapPin, ChevronDown } from "lucide-react";

export default function CityFilter({ options, value, onChange }) {
  const [q, setQ] = useState("");
  const all = Array.from(new Set([...options, ...value]));
  const shown = all.filter((c) => c.toLowerCase().includes(q.toLowerCase()));
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  const label = value.length === 0 ? "All locations" : value.length <= 2 ? value.join(", ") : `${value.length} locations`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-9 min-w-44 justify-between" data-testid="city-filter-trigger">
          <span className="flex items-center gap-1.5 truncate"><MapPin className="h-4 w-4 text-gray-500" />{label}</span>
          <ChevronDown className="h-4 w-4 text-gray-400" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="bg-white w-64 p-2" data-testid="city-filter-popover">
        <Input placeholder="Find a location…" value={q} onChange={(e) => setQ(e.target.value)} className="h-8 mb-2" data-testid="city-filter-search" />
        <div className="max-h-64 overflow-y-auto space-y-0.5">
          {shown.length === 0 && <div className="text-xs text-gray-400 px-2 py-3">No locations</div>}
          {shown.map((c) => (
            <label key={c} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-gray-50 cursor-pointer text-sm" data-testid={`city-option-${c}`}>
              <Checkbox checked={value.includes(c)} onCheckedChange={() => toggle(c)} />{c}
            </label>
          ))}
        </div>
        {value.length > 0 && (
          <button onClick={() => onChange([])} className="w-full text-xs text-gray-500 hover:text-gray-900 border-t border-gray-100 mt-2 pt-2" data-testid="city-filter-clear">Clear selection</button>
        )}
      </PopoverContent>
    </Popover>
  );
}
